.alert {
  min-height: 100px;
}

.alert-text-input {
  textarea {
    margin-bottom: 0;
    min-height: 2.5rem;
    width: 100%;
    max-width: none;
    resize: none;
    line-height: 1.5;
    padding: 0.5rem 0.75rem;
  }
}

.alert-table-cell {
  white-space: normal !important;
}
